// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/network/network.proto" (package "mlmbox.client.network", syntax proto3)
// tslint:disable
import { Account_Info_List } from "../../types/account.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TreeAccount_Set } from "../../types/account.ts";
import { Account_Info } from "../../types/account.ts";
import { Sort } from "../../types/sort.ts";
import { Account_Id } from "../../types/account.ts";
/**
 * @generated from protobuf message mlmbox.client.network.AccountsSearchRequest
 */
export interface AccountsSearchRequest {
    /**
     * @generated from protobuf field: string login_prefix = 1;
     */
    loginPrefix: string;
    /**
     * @generated from protobuf field: uint32 limit = 2;
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated uint32 filter_channels = 3;
     */
    filterChannels: number[];
}
/**
 * @generated from protobuf message mlmbox.client.network.TeamRequest
 */
export interface TeamRequest {
    /**
     * @generated from protobuf field: mlmbox.types.Account.Id view_partner = 1;
     */
    viewPartner?: Account_Id;
    /**
     * @generated from protobuf field: mlmbox.types.Sort partners_sort = 2;
     */
    partnersSort?: Sort;
    /**
     * @generated from protobuf field: int32 filter_tree_ids_bit_mask = 3;
     */
    filterTreeIdsBitMask: number;
    /**
     * @generated from protobuf field: repeated uint32 filter_channels = 4;
     */
    filterChannels: number[];
}
/**
 * @generated from protobuf message mlmbox.client.network.TeamResponse
 */
export interface TeamResponse {
    /**
     * @generated from protobuf field: mlmbox.types.Account.Info account = 1;
     */
    account?: Account_Info;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Account.Info partners = 2;
     */
    partners: Account_Info[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Account.Info referrals = 3;
     */
    referrals: Account_Info[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.TreeAccount.Set account_tree_accounts = 4;
     */
    accountTreeAccounts: TreeAccount_Set[];
}
/**
 * @generated from protobuf message mlmbox.client.network.TeamPartnerListRequest
 */
export interface TeamPartnerListRequest {
    /**
     * @generated from protobuf field: mlmbox.client.network.TeamRequest request = 1;
     */
    request?: TeamRequest;
    /**
     * @generated from protobuf field: uint32 step_referral_branch = 2;
     */
    stepReferralBranch: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class AccountsSearchRequest$Type extends MessageType<AccountsSearchRequest> {
    constructor() {
        super("mlmbox.client.network.AccountsSearchRequest", [
            { no: 1, name: "login_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "limit", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "filter_channels", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<AccountsSearchRequest>): AccountsSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.loginPrefix = "";
        message.limit = 0;
        message.filterChannels = [];
        if (value !== undefined)
            reflectionMergePartial<AccountsSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountsSearchRequest): AccountsSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string login_prefix */ 1:
                    message.loginPrefix = reader.string();
                    break;
                case /* uint32 limit */ 2:
                    message.limit = reader.uint32();
                    break;
                case /* repeated uint32 filter_channels */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.filterChannels.push(reader.uint32());
                    else
                        message.filterChannels.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountsSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string login_prefix = 1; */
        if (message.loginPrefix !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.loginPrefix);
        /* uint32 limit = 2; */
        if (message.limit !== 0)
            writer.tag(2, WireType.Varint).uint32(message.limit);
        /* repeated uint32 filter_channels = 3; */
        if (message.filterChannels.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.filterChannels.length; i++)
                writer.uint32(message.filterChannels[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.network.AccountsSearchRequest
 */
export const AccountsSearchRequest = new AccountsSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TeamRequest$Type extends MessageType<TeamRequest> {
    constructor() {
        super("mlmbox.client.network.TeamRequest", [
            { no: 1, name: "view_partner", kind: "message", T: () => Account_Id },
            { no: 2, name: "partners_sort", kind: "message", T: () => Sort },
            { no: 3, name: "filter_tree_ids_bit_mask", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "filter_channels", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<TeamRequest>): TeamRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterTreeIdsBitMask = 0;
        message.filterChannels = [];
        if (value !== undefined)
            reflectionMergePartial<TeamRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TeamRequest): TeamRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Account.Id view_partner */ 1:
                    message.viewPartner = Account_Id.internalBinaryRead(reader, reader.uint32(), options, message.viewPartner);
                    break;
                case /* mlmbox.types.Sort partners_sort */ 2:
                    message.partnersSort = Sort.internalBinaryRead(reader, reader.uint32(), options, message.partnersSort);
                    break;
                case /* int32 filter_tree_ids_bit_mask */ 3:
                    message.filterTreeIdsBitMask = reader.int32();
                    break;
                case /* repeated uint32 filter_channels */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.filterChannels.push(reader.uint32());
                    else
                        message.filterChannels.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TeamRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Account.Id view_partner = 1; */
        if (message.viewPartner)
            Account_Id.internalBinaryWrite(message.viewPartner, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Sort partners_sort = 2; */
        if (message.partnersSort)
            Sort.internalBinaryWrite(message.partnersSort, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 filter_tree_ids_bit_mask = 3; */
        if (message.filterTreeIdsBitMask !== 0)
            writer.tag(3, WireType.Varint).int32(message.filterTreeIdsBitMask);
        /* repeated uint32 filter_channels = 4; */
        if (message.filterChannels.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.filterChannels.length; i++)
                writer.uint32(message.filterChannels[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.network.TeamRequest
 */
export const TeamRequest = new TeamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TeamResponse$Type extends MessageType<TeamResponse> {
    constructor() {
        super("mlmbox.client.network.TeamResponse", [
            { no: 1, name: "account", kind: "message", T: () => Account_Info },
            { no: 2, name: "partners", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Account_Info },
            { no: 3, name: "referrals", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Account_Info },
            { no: 4, name: "account_tree_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TreeAccount_Set }
        ]);
    }
    create(value?: PartialMessage<TeamResponse>): TeamResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.partners = [];
        message.referrals = [];
        message.accountTreeAccounts = [];
        if (value !== undefined)
            reflectionMergePartial<TeamResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TeamResponse): TeamResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Account.Info account */ 1:
                    message.account = Account_Info.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* repeated mlmbox.types.Account.Info partners */ 2:
                    message.partners.push(Account_Info.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Account.Info referrals */ 3:
                    message.referrals.push(Account_Info.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.TreeAccount.Set account_tree_accounts */ 4:
                    message.accountTreeAccounts.push(TreeAccount_Set.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TeamResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Account.Info account = 1; */
        if (message.account)
            Account_Info.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Account.Info partners = 2; */
        for (let i = 0; i < message.partners.length; i++)
            Account_Info.internalBinaryWrite(message.partners[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Account.Info referrals = 3; */
        for (let i = 0; i < message.referrals.length; i++)
            Account_Info.internalBinaryWrite(message.referrals[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.TreeAccount.Set account_tree_accounts = 4; */
        for (let i = 0; i < message.accountTreeAccounts.length; i++)
            TreeAccount_Set.internalBinaryWrite(message.accountTreeAccounts[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.network.TeamResponse
 */
export const TeamResponse = new TeamResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TeamPartnerListRequest$Type extends MessageType<TeamPartnerListRequest> {
    constructor() {
        super("mlmbox.client.network.TeamPartnerListRequest", [
            { no: 1, name: "request", kind: "message", T: () => TeamRequest },
            { no: 2, name: "step_referral_branch", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<TeamPartnerListRequest>): TeamPartnerListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepReferralBranch = 0;
        if (value !== undefined)
            reflectionMergePartial<TeamPartnerListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TeamPartnerListRequest): TeamPartnerListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.client.network.TeamRequest request */ 1:
                    message.request = TeamRequest.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* uint32 step_referral_branch */ 2:
                    message.stepReferralBranch = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TeamPartnerListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.client.network.TeamRequest request = 1; */
        if (message.request)
            TeamRequest.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 step_referral_branch = 2; */
        if (message.stepReferralBranch !== 0)
            writer.tag(2, WireType.Varint).uint32(message.stepReferralBranch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.network.TeamPartnerListRequest
 */
export const TeamPartnerListRequest = new TeamPartnerListRequest$Type();
/**
 * @generated ServiceType for protobuf service mlmbox.client.network.Network
 */
export const Network = new ServiceType("mlmbox.client.network.Network", [
    { name: "MemberGet", options: {}, I: Account_Id, O: Account_Info },
    { name: "MemberSearch", options: {}, I: AccountsSearchRequest, O: Account_Info_List },
    { name: "TeamInfo", options: {}, I: TeamRequest, O: TeamResponse },
    { name: "TeamSearch", options: {}, I: AccountsSearchRequest, O: Account_Info_List },
    { name: "TeamPartnerList", options: {}, I: TeamPartnerListRequest, O: Account_Info_List }
]);
